import { ExamineeContactInfo } from "../../../store/newExamineeSlice";
import { ChooseAssessmentForm } from "./steps/ChooseAssessmentForm";

export const StartAssessmentBody = ({
    examinee,
    locationId,
    upcomingAssessmentId,
    onEditExamineeEmail
}: StartAssessmentBodyProps): JSX.Element => {
    return (
        <>
            <p className="has-text-centered has-text-weight-bold is-size-3">{`${examinee.firstName} ${examinee.lastName}`}</p>
            <div className="is-flex">
                <ChooseAssessmentForm
                    examinee={examinee}
                    locationId={locationId}
                    upcomingAssessmentId={upcomingAssessmentId}
                    onEditExamineeEmail={onEditExamineeEmail}
                />
            </div>
        </>
    );
};

interface StartAssessmentBodyProps {
    examinee: ExamineeContactInfo;
    locationId: number;
    upcomingAssessmentId?: number;
    onEditExamineeEmail?: () => void;
}
